// extracted by mini-css-extract-plugin
export default {"wrapper":"so-z","response":"to-z","error":"uo-z","disabled":"vo-z","buttons":"wo-z","feedbackQuestionSection":"xo-z","yesNoWrapper":"yo-z"};